import { ITipoItem, IDepartamento } from '../types';
import api from '~/services/api';

/* =========================
   UNIDADES
========================= */
export const fetchUnidades = async () => {
  const res = await api.get('/unidade');
  const { data, success } = res.data;
  if (!success) return { unCompras: [], unVendas: [] };

  const unCompras = data[0].map((unidade: any) => ({
    value: unidade.des_unidade,
    label: `${unidade.des_unidade} - ${unidade.des_medida}`,
  }));

  const unVendas = data[1].map((unidade: any) => ({
    value: unidade.des_unidade,
    label: `${unidade.des_unidade} - ${unidade.des_medida}`,
  }));

  unCompras.unshift({ value: null, label: 'Nenhum' });

  return { unCompras, unVendas };
};

/* =========================
   ID CONTÁBEIS
========================= */
export const fetchIdContabeis = async () => {
  const { data } = await api.get('/perfil-documento-id-contabil');
  if (!data.success) return [];

  return data.data
    .map((c: any) => ({
      label: `${c.cod_id_ctb} - ${c.des_id_ctb}`,
      value: c.cod_id_ctb,
    }))
    .sort((a: any, b: any) => a.value - b.value);
};

/* =========================
   TIPO ITEM
========================= */
export const fetchTipoItem = async () => {
  const { data } = await api.get('/tipo_item');
  if (!data.success) return [];

  return data.data
    .map((tipo: ITipoItem) => ({
      label: `${tipo.num_tipo_item} - ${tipo.des_tipo_item}`,
      value: tipo.cod_tipo_item,
    }))
    .sort((a: any, b: any) => a.value - b.value);
};

/* =========================
   DEPARTAMENTOS
========================= */
export const fetchDepartamentos = async () => {
  const res = await api.get('/produto/departamentos');
  const { data, success } = res.data;
  if (!success) return [];

  return data.map((item: IDepartamento) => ({
    value: item.cod_departamento,
    label: `${item.cod_departamento} - ${item.descricao}`,
    cod_tipo_item: item.cod_tipo_item,
    des_tipo_item: item.des_tipo_item,
    cod_id_ctb: item.cod_id_ctb,
  }));
};

/* =========================
   TIPOS DE AJUSTE
========================= */
export const fetchTiposDeAjustes = async () => {
  const res = await api.get('/tipoajusteestoque/tipos-de-para');
  const { data, success } = res.data;
  if (!success) return [];

  return data.rowsEntrada.map((item: any) => ({
    value: item.cod_tipo_ajuste,
    label: `${item.cod_tipo_ajuste} - ${item.des_tipo_operacao} ${item.des_ajuste}`,
  }));
};

/* =========================
   VASILHAMES
========================= */
export const fetchVasilhames = async () => {
  const res = await api.get('/produto/vasilhame');
  const { data } = res.data;
  if (!data) return [];

  return (data as { cod_produto: string; des_produto: string }[]).map(
    (produto) => ({
      label: `${produto.cod_produto} - ${produto.des_produto}`,
      value: produto.cod_produto,
    }),
  );
};

/* =========================
   OPTIONS ENTRADA PIS COFINS
========================= */
export const fetchPisCofins = async () => {
  const { data } = await api.get('/produto/consulta-credito-presumido');
  if (!data.success || !data.data) return [];

  const values = data.data.map((item: any) => ({
    value: item.cod_cred_pres,
    label: item.descricao,
  }));

  return [{ value: null, label: '= Saída' }, ...values];
};

/* =========================
   TRIBUTAÇÕES SAIDA
========================= */
export const fetchTributacoesSaida = async () => {
  const { data } = await api.get('/tributacao?type=saida');
  if (!data.success || !data.data) return [];

  return data.data.map((i: any) => ({
    value: i.cod_tributacao,
    label: `${i.des_tributacao} ${
      i.cod_situacao_tributaria ? ` - ${i.cod_situacao_tributaria}` : ''
    }`,
  }));
};

/* =========================
   TRIBUTAÇÕES ENTRADA
========================= */
export const fetchTributacoesEntrada = async () => {
  const { data } = await api.get('/tributacao');
  if (!data.success || !data.data) return [];

  return data.data.map((i: any) => ({
    value: i.cod_tributacao,
    label: `${i.des_tributacao} ${
      i.cod_situacao_tributaria ? ` - ${i.cod_situacao_tributaria}` : ''
    }`,
  }));
};
